const state = {
    subscriptions: {}
};
export default state;
